import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IAuditWithUserInterface} from '../../../global/audit.interface';
import {IPageableResponse} from '../../../global/pagging.dto';
import {IAdvanceFilter} from '../../shared/advanced-filters/components/advance-filter';
import {Signable} from '../../signing-pages/signing-sidebar/activity-logs/activity-logs-dto';
import {ContractControlAdvanceFilterParamType} from '../contract-control/advanced-filters';
import {DefaultFilter} from '../contract-control/contract-control-interfaces/default-filters.interface';
import {DocumentType, PeriodRenewal, Todo} from '../contract-control/contract-control.dto';
import {Sectionable} from '../contract-control/store/dto/cc-documents-list.dto';
import {IGetContractControlDataResponse} from '../contract-control/store/dto/contract-control-view';
import {IGetDocumentByIdAndNumber} from '../documents/dto/document-listing.dto';
import {CcDashboardChartRequestBuilder} from './cc-dashboard-chart-request-builder';


export interface IDashboardUpcomingEventsRequest{
    filter: number,
    document_type_id?: number,
    status?: string,
    category_ids?: number | number[] | 'no_category',
    advanced?:  ContractControlAdvanceFilterParamType[]
}

@Injectable({
    providedIn: 'root'
})

export class DashboardService {
    constructor(private http: HttpClient) {

    }



    /**
     * Get Upcoming graph data
     * @returns response
     */
    upcomingEvents(months: number, filter: DefaultFilter, advancedFilter?: IAdvanceFilter<ContractControlAdvanceFilterParamType>[]){
       const requestBuilder: CcDashboardChartRequestBuilder = new CcDashboardChartRequestBuilder();

       const filters = requestBuilder
           .documentType(filter?.document_type)
           .status(filter?.status)
           .categories(filter?.category_ids)
           .advancedFilters(advancedFilter || [])
           .build(months)
        
       
        return this.http.post<IGetDashboardUpcommingEvents[]>(`dashboard/upcomming-events`,filters);
    }

    /**
     * Last Signed Documents
     * @returns 
     */
    lastSignedDocuments(){
        return this.http.get('dashboard/last-signed-documents');
    }


    
    /**
     * Email Bounced Documents
     * @returns 
     */
    emailBouncedDocuments(){
        return this.http.get('dashboard/email-bounced');
    }


    /**
     * Expire Contract (Contract Control)
     * @returns 
     */
    expireContracts(){
        return this.http.get<PeriodRenewal[]>('dashboard/contracts-expires-on');
    }



    mostActiveUsers(){
        return this.http.get<IMostActiveUsers[]>('dashboard/most-active-users');
    }
    
    /**
     * Get Dashboard settings
     * @returns 
     */
    getSettings(){
        return this.http.get<IGetDashboardSettings[]>('dashboard/dashboard-settings');
    }

    /**
     * Update setting
     * */
    updateSetting(key: string, value: string){
        return this.http.post('dashboard/dashboard-settings',{'key':key, 'value': value});
    }

    /**
     * Fetch Latest Activity
     * @returns 
     */
    latestActivity(){
        return this.http.get<IPageableResponse<Sectionable>>('dashboard/latest-activity');
    }

    /**
     * Fetch Most User Templates
     * @returns 
     */
    mostUsedTemplates(){
        return this.http.get<IMostActiveTemplate[]>('dashboard/most-used-templates');
    }

    /**
     * Fetch About to expire
     * @returns 
     */
    aboutToExpire(){
        return this.http.get<[]>('dashboard/about-to-expire');
    }

    /**
     * Fetch Unread chat messages
     * @returns 
     */
    unreadChatMessages(){
        return this.http.get<Signable[]>('dashboard/unread-chat-messages');
    }

    /**
     * Fetch Forgotten documents
     * @returns 
     */
    forgottenDocuments(){
        return this.http.get<IGetDocumentByIdAndNumber[]>('dashboard/forgotten-documents');
    }

    /**
     * Fetch auto renewal on
     * @returns 
     */
    autoRenewalOn(){
        return this.http.get<IPageableResponse<IGetAutoRenewalOn>>('dashboard/contracts-auto-renewal-on');
    }


    /**
     * Fetch Task and Reminder Settings
     * @returns 
     */
    fetchTaskAndReminderSettings(){
        return this.http.get<Todo[]>('todos');
    }
}

export interface IGetDashboardUpcommingEvents {
    todoEvents: {
        label: string;
    }[];
    periodRenewalEvents: {
        auto_notice: number; auto_renew: number; notice: number | string; expire: string
    };
}

export interface IGetDashboardSettings extends IAuditWithUserInterface{
    id:  number;
    key: string;
    value:string;
    workspace_id:number;
}

export interface IMostActiveUsers {
    id: number;
    name: string;
    email: string;
    login_attempts_count:number;
}

export interface IMostActiveTemplate{
    name:string;
    document_type_id:number;
    used:number,
    document_type:DocumentType
}

export interface IGetAutoRenewalOn extends PeriodRenewal{
    contract_control:IGetContractControlDataResponse
}
